<div class="form-group">
  @if (label) {
    <label class="fw-bold">{{ label }}</label>
  }
  <div class="select-wrapper">

    @if (!hasDots) {
      <select
        class="form-select"
        [formControl]="selectFormControl"
        [class.is-invalid]="selectFormControl && selectFormControl.invalid && (selectFormControl.touched || selectFormControl.dirty)"
        [class.is-valid]="selectFormControl && selectFormControl.valid && (selectFormControl.touched || selectFormControl.dirty)"
        (change)="onValueChange($event.target)"
        >
        @for (option of options; track option.key) {
          <option
            [value]="option.key">
            {{ option.value }}
          </option>
        }
      </select>
    }

    @if (hasDots) {
      <div class="dot-select"
        [class.is-invalid]="selectFormControl && selectFormControl.invalid && (selectFormControl.touched || selectFormControl.dirty)"
        [class.is-valid]="selectFormControl && selectFormControl.valid && (selectFormControl.touched || selectFormControl.dirty)"
        [class.disabled]="selectFormControl.disabled"
        [class.open]="isOpen">
        <div class="dot-select-trigger" (click)="toggleDropdown()">
          <span class="status-dot" [ngClass]="selectedOption?.dotClass || 'dot-none'"></span>
          <span class="dot-select-label">{{ selectedOption?.value || 'Select...' }}</span>
          <i class="fa fa-chevron-down dot-chevron"></i>
        </div>
        @if (isOpen) {
          <div class="dot-select-options">
            @for (option of options; track option.key) {
              <div class="dot-select-option"
                [class.active]="String(selectFormControl.value) === String(option.key)"
                (click)="pickOption(option)">
                <span class="status-dot" [ngClass]="option.dotClass || 'dot-none'"></span>
                <span>{{ option.value }}</span>
                @if (String(selectFormControl.value) === String(option.key)) {
                  <i class="fa fa-check ms-auto"></i>
                }
              </div>
            }
          </div>
        }
      </div>
      @if (isOpen) {
        <div class="dot-select-backdrop" (click)="isOpen = false"></div>
      }
    }

  </div>
  @if (selectFormControl && selectFormControl.invalid && (selectFormControl.touched || selectFormControl.dirty)) {
    <div class="text-danger small">
      @if (selectFormControl.errors?.['required']) {
        <span>
          <i class="fa fa-exclamation-circle me-1"></i>Required field
        </span>
      }
      @if (selectFormControl.errors?.['back']) {
        <span>
          <i class="fa fa-exclamation-circle me-1"></i>{{ selectFormControl.errors?.['back'] }}
        </span>
      }
    </div>
  }

</div>